module.exports = __webpack_public_path__ + "static/media/Rococo Aristocrat.fadd4dad.jpg";